/** Created by azhou on 2018/7/24.*/
<template>
  <div class="text-left">
    <h5>1 会员登录</h5>
    <p>
      已完成注册的会员用户（以下简称"会员"）方可使用本平台。禁止代理登陆、ID及密码的出借、转让等行为；会员的ID及密码由会员自己负责保存和管理。
    </p>
    <h5>2 适用范围</h5>
    <p>
      本规章适用于所有登陆并使用本平台的会员。会员完成登陆的同时，即拥有诚实遵守本规章的责任和义务。
    </p>
    <h5>3 本平台的服务内容</h5>
    <p>会员可以通过本平台免费使用以下服务：</p>
    <p>01．"订单雨"的场地预订和套餐预订服务</p>
    <p>（1）本预订平台中已有的住宿设施的检索、信息介绍</p>
    <p>（2）本预订平台中已有的会议场地的预订</p>
    <p>（3）本预订平台中已有的产品服务的预订取消</p>
    <p>02．"订单雨"的短信服务平台</p>
    <p>本网站将免费提供关于会员认证及网站活动的短信。</p>
    <p>03．"订单雨"的公众号服务平台</p>
    <p>本网站将定时为会员发送公众号杂志，提供订单雨的特色产品以及仅针对会员进行的促销活动信息。</p>


    <h5>4 他人使用本平台</h5>
    <p>会员应妥善保存和管理本公司给与的ID和密码。若被他人使用，本公司将一概视为会员本人在使用。在此情况下会员所蒙受的一切损失，本公司恕不负责。</p>

    <h5>5 服务的中止-中断</h5>
    <p>本公司在符合以下事项的情况下，可以不做事前通知而停止经营或中断服务。此时由本平台停止或中断经营造成的会员损失本公司恕不负责。</p>
    <p>（1）本平台定期维护或发生紧急事件。</p>
    <p>（2）因战争、暴动、骚乱、劳资纠纷、地震、洪水、停电等紧急事态，造成本平台无法正常运作。</p>
    <p>（3）会员有违反本规章的事实存在，本公司认定必要的情况。</p>
    <p>（4）其他的在本平台运营过程中，本公司认定需要暂时中断的情况。</p>

    <h5>6 免责声明</h5>
    <p>01．在使用本平台时，由于网络运营商等第三方或平台故障导致的无法提供服务时，本公司不负任何责任。</p>
    <p>02．因本平台提供的信息内容，（包括会员在内的第三方之间发生纠纷时），本公司将会拿出诚意，和您一起妥善对待和解决此纠纷。</p>

    <h5>7 禁止事项</h5>
    <p>01. 使用本平台时，会员不应采取以下行为。</p>
    <p>（1）侵害其他会员、第三方或者本公司的权利，或者可能侵害的行为</p>
    <p>（2）侵害其他会员、第三方或者本公司的财产及隐私，或者可能侵害的行为</p>
    <p>（3）除上列（1）（2）之外，使其他会员、第三方或者本公司蒙受损失，或者使其可能蒙受损失的行为</p>
    <p>（4）违反公共秩序和道德观念，或者可能违反的行为</p>
    <p>（5）犯罪行为、与犯罪行为关联或者可能犯罪的行为</p>
    <p>（6）未得到本公司允许，通过本平台或者与本平台关联的以营利为目的的行为，或者以其准备为目的的行为</p>
    <p>（7）非法使用注册帐号及密码的行为</p>
    <p>（8）用虚假信息进行会员登记的行为</p>
    <p>（9）使用电脑病毒等有害程序侵害本平台及其相关，或提供有害程序的行为</p>
    <p>（10）违反法律，或可能违反的行为</p>
    <p>（11）其他本公司判断为不适宜的行为</p>
    <p>02. 若被认定符合上述行为，本公司将保留删除该会员帐号的权力，并不事先通知。另外，会员应小心使用第三方或酒店设施万一发生使第三方或酒店蒙受损失的行为，会员应承担一切责任。 </p> 
     
    <h5>8 个人信息的处理</h5>
    <p>01. 本公司通过业务关系得到的会员个人信息，将作以下用途。</p>
    <p>（1）将客人的申请信息用于同客人需入住酒店之间的联系</p>
    <p>（2）为使本公司提供的服务内容更丰富</p>
    <p>（3）必要时用于同客人进行联系</p>
    <p>（4）用于设施使用情况和使用环境等相关调查，业务合作的设施等面向本公司内部的各类报告（属性的统计、分析等不针对个人的形式）</p>
    <p>02. 通过业务关系得到的会员个人情报，本公司在下列情况中可将个人资料提供给业务合作商等第三方。</p>
    <p>（1）会员本人同意。</p>
    <p>（2）以第1项条款为利用目的必要情况。</p>
    <p>（3）为犯罪搜查等警察、检察、法院、律师协会或其同等权限机关的明确请求。</p>
    <p>（4）为保护会员的人身、财产安全时的紧急情况。</p>
    <p>03. 本公司会根据会员要求，停止向第三方提供会被其识别出本人身份的个人资料。（但是，也有可能无法使用本公司提供的服务）。</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    components: {}
  }
</script>
<style lang="scss" scoped>
  h5{font-weight: bold}
  p{ color: #aaa;}
</style>
